import React from "react";
import "./template.css";
import {
  Box,
  Text,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Flex,
} from "@chakra-ui/react";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { Col, Row } from "react-bootstrap";
import { Divider } from "rsuite";
import TermsAndConditions from "./commonComponent/termsAndConditions";
import BankDetails from "./commonComponent/bankDetails";
import { calculateItemGstAmount } from "../uttils/calculateItemGstAmount";
import InvoiceBankDetails from "./commonComponent/invoiceBankDetails";

const ShowAddress = ({address}) => {
  if (!address) return {};
  const city = address.cityName;
  const country = address.countryName;
  const state = address.stateName;
  return (
    <>
      {address?.s1 && <p>{address?.s1}</p>}
      {address?.s2 && <p>{address?.s2}</p>}
      <p>{city ? `${city},` : ""}{state}</p>
      <p>{country ? country : ""}{address?.pin ? `,${address?.pin}` : ""}</p>
    </>
  )
}

const DefaultInvoiceTemplate = ({
  title,
  idNo,
  invoice,
  invoiceDate,
  invoiceTerms,
  invoiceCurrency,
  invSub,
  itemList,
  currency,
  clientId,
  clientGst,
  gst,
  totalAmount,
  freightCharge,
  adjustment,
  customerNotes,
  totalPaymentAmount,
  dueDate,
  orgAddress,
  clientAddress,
  clientDetail,
  logoUrl,
  organizationData,
  selectedBankDetails,
  isProforma
}) => {
  return (
    <Box className="invoice-order-pdf">
      <Box id="DefaultTemplate" className="main-template">
        <Box
          display="flex"
          justifyContent="space-between"
          className="purchase-order-header"
        >
          <Flex
            // align="center"
            direction="row"
            className="payment-pdf-logo mb-0"
          >
            <img src={logoUrl} alt="logo" />
          </Flex>
          <Box className="top-heading">
            <Text className="heading-text">{title}</Text>
            <Text className="poNo-text mt-2 text-end"># {idNo}</Text>
          </Box>
        </Box>
        <Box
          display="flex"
          className="payment-pdf-header"
          justifyContent="space-between"
        >
          <div className="header-box">
            <Text className="title">{organizationData?.name}</Text>
            <Text className="address">
              <ShowAddress address={orgAddress} />
            </Text>
            <Text className="address">
              <span>Company ID :</span>
              <span> {organizationData?.cpId}</span>
            </Text>
            <Text className="address">
              <span><strong>GSTIN:</strong></span>
              <span> {organizationData?.gstNo}</span>
            </Text>
          </div>
        </Box>
        <Box className="vendor-address-box">
          <Box
            display="flex"
            className="payment-pdf-header"
            justifyContent="space-between"
          >
            <div className="header-box">
              <Text className="address" style={{ fontWeight: 600 }}>
                Bill To
              </Text>
              <Text className="title">{clientDetail?.clName}</Text>
              <Text className="address">
                <ShowAddress address={clientAddress} />
              </Text>

              <Text className="address">
                <span><strong>GSTIN:</strong></span>
                <span> {clientGst || "NA"}</span>
              </Text>
            </div>
          </Box>
          <Box className="order-details">
            <div className="order-details-list">
              <div className="list-heading">{invoice?.heading} :</div>
              <div className="list-value text-end">{invoice?.value}</div>
            </div>
            <div className="order-details-list">
              <div className="list-heading">{invoiceDate?.heading} :</div>
              <div className="list-value text-end">{invoiceDate?.value}</div>
            </div>
            <div className="order-details-list">
              <div className="list-heading">{invoiceTerms?.heading} :</div>
              <div className="list-value text-end">{invoiceTerms?.value}</div>
            </div>
            <div className="order-details-list">
              <div className="list-heading">Due Date:</div>
              <div className="list-value text-end">{dueDate?.value || "NA" }</div>
            </div>
            <div className="order-details-list">
              <div className="list-heading">{invoiceCurrency?.heading} :</div>
              <div className="list-value text-end">{invoiceCurrency?.value}</div>
            </div>
          </Box>
        </Box>
        {invSub?.value && (
          <Box className="subject" display="flex" gap="0.5rem">
            <Text fontWeight="bold">{invSub?.heading}:</Text>
            <Text marginTop={0}> {invSub?.value}</Text>
          </Box>
        )}
        <div className="payment-table-box ">
          <Table>
            <Thead>
              <Tr>
                <Th width={8}>#</Th>
                <Th width={225}>Item & Description </Th>
                <Th className="text-end">Qty</Th>
                <Th className="text-end">Rate </Th>
                <Th className="text-center">Tax</Th>
                {currency?.code === 'INR' && <Th className="text-end">{gst?.type === 'IGST' ? "IGST" :"CGST & SGST"}</Th>}
                <Th className="text-end">Amount</Th>
              </Tr>
            </Thead>
            <Tbody>
              {itemList &&
                itemList?.length &&
                itemList.map((item, i) => {
                  return (
                    <Tr>
                      <Td>{i + 1}</Td>
                      <Td className="item-data">
                        <Text className="name">{item?.slItm?.name}</Text>
                        <Text className="description">{item?.slItm?.dc}</Text>
                        <Text className="mt-2">
                          {item?.slItm?.hCd ? "HSN Code:" : "SAC:"}{" "}
                          {item?.slItm?.hCd || item?.slItm?.sCd}
                        </Text>
                      </Td>

                      <Td className="text-end">{item?.qty}</Td>
                      <Td className="text-end">
                        {" "}
                        {formatAmountIndianRupees(item?.prc || 0)}
                      </Td>
                      <Td className="text-center">{item?.tax?.label || "-"}</Td>
                      {currency?.code === 'INR' &&<Td className="text-end">{formatAmountIndianRupees(calculateItemGstAmount(item) || 0)}</Td>}
                      <Td className="text-end">
                        {formatAmountIndianRupees(item?.amt || 0)}
                      </Td>
                    </Tr>
                  );
                })}
            </Tbody>
          </Table>
        </div>
        <Box className="total-details">
          <Row>
            <Col></Col>
            <Col>
              <div className="total-amount-details">
                <div className="heading">Sub Total</div>
                <div className="value text-end">
                  {formatAmountIndianRupees(totalAmount || 0)}{" "}
                  {currency?.symbol || "₹"}
                </div>
              </div>
              {currency.code === "INR" ? (
                <>
                  {gst?.type === "IGST" ? (
                    <div className="total-amount-details">
                      <div className="heading">IGST</div>
                      <div className="value text-end">
                        {formatAmountIndianRupees(gst?.amount?.i || 0)}{" "}
                        {currency?.symbol || "₹"}
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="total-amount-details">
                        <div className="heading">SGST</div>
                        <div className="value text-end">
                          {formatAmountIndianRupees(gst?.amount?.s || 0)}{" "}
                          {currency?.symbol || "₹"}
                        </div>
                      </div>
                      <div className="total-amount-details">
                        <div className="heading">CGST</div>
                        <div className="value text-end">
                          {formatAmountIndianRupees(gst?.amount?.c || 0)}{" "}
                          {currency?.symbol || "₹"}
                        </div>
                      </div>
                    </>
                  )}
                </>
              ) : (
                ""
              )}
              {freightCharge ? (
                <div className="total-amount-details">
                  <div className="heading">Freight Charges</div>
                  <div className="value text-end">
                    {formatAmountIndianRupees(freightCharge || 0)}{" "}
                    {currency?.symbol || "₹"}
                  </div>
                </div>
              ) : (
                ""
              )}
              {adjustment?.value ? (
                <div className="total-amount-details">
                  <div className="heading">{adjustment?.heading}</div>
                  <div className="value text-end">
                    {formatAmountIndianRupees(adjustment?.value || 0)}{" "}
                    {currency?.symbol || "₹"}
                  </div>
                </div>
              ) : (
                ""
              )}
              <div
                className="total-amount-details  final-amount "
                style={{ alignItems: "center" }}
              >
                <div className="heading text-bold">Total</div>
                <div className="value text-bold text-end">
                  {formatAmountIndianRupees(totalPaymentAmount)}{" "}
                  {currency?.symbol || "₹"}
                </div>
              </div>
            </Col>
          </Row>
        </Box>

        <Box className="terms-condtions">
          <Text className="fw-600">Customer Notes</Text>
          <Text marginBottom="1rem" marginTop={0}>{customerNotes}</Text>
          <Box className={organizationData?.isBnk ? "bank-info-tc-container" : ""}>
          {/* <BankDetails /> */}
          {organizationData?.isBnk && <InvoiceBankDetails bankDetails={selectedBankDetails} />}
          <div>
          <TermsAndConditions headingClassName="fw-600" isProforma={isProforma}/>
          </div>
          </Box>
        </Box>
        <Box className="pdf-footer1" id="po-footer">
          <Divider className="footer-divider" />
          <Text className="footer-text">{isProforma ? organizationData?.pfFtxt :organizationData?.sFtxt}</Text>
        </Box>
      </Box>
    </Box>
  );
};

export default DefaultInvoiceTemplate;
